import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

function ProtectedRoute({ children, allowedRoles = [], menu, action = "read" }) {
  const { isAuthenticated, isInitializing, hasRole } = useAuth();
  const location = useLocation();

  if (isInitializing) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-100 text-slate-700 transition-colors duration-300 dark:bg-slate-900 dark:text-slate-100">
        <div className="rounded-2xl border border-slate-200 bg-white px-6 py-4 shadow-lg shadow-slate-200/50 dark:border-slate-800 dark:bg-slate-900 dark:shadow-black/20">
          Loading session...
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }

  if (allowedRoles.length > 0) {
    const isAllowed = allowedRoles.some((roleName) => hasRole(roleName));
    if (!isAllowed) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  if (menu && action) {
    const actionKeyMap = {
      create: "isCreate",
      read: "isRead",
      update: "isUpdate",
      delete: "isDelete",
    };
    const actionKey = actionKeyMap[String(action).toLowerCase()] || action;
    if (!menu?.permissions?.[actionKey]) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return children;
}

export default ProtectedRoute;
